import {
  AbilityBuilder,
  createMongoAbility,
  MongoAbility,
} from "@casl/ability";
import { UserFields } from "../types/user.types";

type Actions =
  'create' |
  'read' |
  'update' |
  'delete' |
  'manage' |
  'update_status' |
  'update_assignment' |
  'change_type';

type Subjects =
  'Request' |
  'Attachment' |
  'Comment' |
  'User' |
  'Contact' |
  'all';

export type AppAbility = MongoAbility<[Actions, Subjects]>;

export default function buildAbilityFor(user: UserFields) {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (user) {
    if (user.roles.includes('admin')) {
      can('manage', 'all');
      can('manage', 'Contact');
      can('update_status', 'Request');
      can('update_assignment', 'Request');
      can('change_type', 'Request');
    }
  }

  return build();
}
